import React, { useState, useEffect, useRef } from 'react';
import { message, Button, Tag } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilter, faSync, faUpload } from '@fortawesome/free-solid-svg-icons';
import CallRecordingsTable from './components/CallRecordingsTable';
import QueueStatusBar from './components/QueueStatusBar';
import { callAnalyticsAPI } from '../../services/callAnalytics';

const RecordingManagement = () => {
  const [campaigns, setCampaigns] = useState([]);
  const [hasActiveFilters, setHasActiveFilters] = useState(false);
  const tableRef = useRef();

  useEffect(() => {
    loadCampaigns();
  }, []);

  const loadCampaigns = async () => {
    try {
      const data = await callAnalyticsAPI.getCampaigns();
      setCampaigns(data.filter(c => c.active));
    } catch (error) {
      message.error('Failed to load campaigns');
      console.error('Load campaigns error:', error);
    }
  };

  const handleFilterClick = () => {
    tableRef.current?.openFilterDrawer();
  };

  const handleRefreshClick = () => {
    tableRef.current?.refresh();
  };

  const handleUploadClick = () => {
    tableRef.current?.openUploadModal();
  };

  return (
    <div>
      {/* Queue Status Bar with Action Buttons */}
      <QueueStatusBar>
        <Button
          icon={<FontAwesomeIcon icon={faFilter} />}
          onClick={handleFilterClick}
          size="large"
          style={{ 
            height: '48px',
            borderRadius: '8px',
            display: 'flex',
            alignItems: 'center'
          }}
        >
          Filters
          {hasActiveFilters && (
            <Tag color="blue" style={{ marginLeft: '8px', borderRadius: '12px' }}>Active</Tag>
          )}
        </Button>
        <Button
          icon={<FontAwesomeIcon icon={faSync} />}
          onClick={handleRefreshClick}
          size="large"
          style={{ 
            height: '48px',
            borderRadius: '8px'
          }}
        >
          Refresh
        </Button>
        <Button
          type="primary"
          icon={<FontAwesomeIcon icon={faUpload} />}
          onClick={handleUploadClick}
          size="large"
          style={{ 
            backgroundColor: '#000',
            borderColor: '#000',
            height: '48px',
            borderRadius: '8px'
          }}
        >
          Upload Recordings
        </Button>
      </QueueStatusBar>

      {/* Recordings Table */}
      <CallRecordingsTable 
        ref={tableRef}
        campaigns={campaigns}
        onFiltersChange={(active) => setHasActiveFilters(active)}
      />
    </div>
  );
};

export default RecordingManagement;
